import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Círculo',
    polygon: 'Polígono',
    zip: 'Código postal',
  },
  fields: {
    name: {
      label: 'Nombre',
    },
    color: {
      label: 'Color',
    },
    min_threshold: {
      label: 'Importe mínimo del pedido',
    },
    max_threshold: {
      label: 'Importe máximo del pedido',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Tarifa de entrega',
      },
      [DeliveryMode.External]: {
        label: 'Tarifa pagada por el restaurante',
      },
    },
    zip_codes: {
      label: 'Códigos postales (uno por línea)',
    },
  },
  labels: {
    hidden: '(oculto)',
  },
  buttons: {
    save: 'Guardar',
    cancel_changes: 'Cancelar cambios',
    add_max_order_amount: 'Agregar importe máximo del pedido',
  },
  modals: {
    delete_confirmation: {
      title: '¿Está seguro de que desea eliminar {{name}}?',
    },
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios para {{name}}',
    delivery_zone_got_updated: 'Cambios guardados correctamente para {{name}}',
    failed_to_delete_delivery_zone: 'Error al eliminar {{name}}',
    delivery_zone_got_deleted: '{{name}} eliminado correctamente',
  },
};
